import { rupees } from 'config/utils';

import sanitizePaymentOptions, {
  getSupportedPaymentInstruments,
} from './paymentOptions';

import {
  getIsMobileDevice,
} from 'utils/ModernizrUtils';

const getLinkInitialState = (state, baseInitialState = {}) => {
  const {
    should_retry: shouldRetry,
  } = state;
  const updatedState = shouldRetry ? state.retry_data : state;

  const {
    link,
  } = updatedState;

  const initialAmount = shouldRetry ? state.payment.amount : link.amount;

  const paymentInstruments = getSupportedPaymentInstruments(
    (state.payment && state.payment.payment_forms) || {}
  );

  return {
    ...baseInitialState,
    isLinkPayment: true,
    totalAmount: initialAmount,
    totalAmountFormatted: rupees(initialAmount),
    offer: {
      basePrice: initialAmount,
    },
    isMobileDevice: getIsMobileDevice(),
    ...sanitizePaymentOptions(paymentInstruments),
  };
};

export default getLinkInitialState;



// WEBPACK FOOTER //
// ./src/payments/reducers/finalize/linkInitialState.js